// Libraries
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';

// Styles
require('styles/index.css');

// History
import { browserHistory } from './../App';

// Interfaces
import { IApp } from 'stores/AllStores';

interface IMainProps extends IApp {
  match: any;
}

// Component
@inject('store')
@observer
export default class Main extends React.Component<IApp, {}> {
  constructor() {
    super();
    browserHistory.push('sales');
  }

  public render() {
    return <div />;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/index.tsx